<template>
  <div :class="bem({ text: textColour })">
    <div
      v-if="image?.responsiveImage"
      :class="bem('img-wrapper')"
    >
      <DatoCmsImage
        :class="bem('img')"
        :data="image.responsiveImage"
        :lazy-load="false"
        :focal-point="image.focalPoint"
        :picture-class="bem('picture')[0]"
        :picture-style="{
          objectFit: 'cover'
        }"
      />
    </div>

    <div :class="bem('copy')">
      <DatoStructuredText
        :class="bem('header')"
        :content="content"
      />
    </div>
  </div>
</template>

<script>
import { Image as DatoCmsImage } from 'vue-datocms'

export default {
  name: 'GenericStyledBanner',

  components: {
    DatoCmsImage
  },

  props: {
    image: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    textColour: {
      type: String,
      validator: val => ['dark', 'light'].includes(val),
      default: 'dark'
    }
  },

  setup () {
    const bem = useBEM('GenericStyledBanner')
    return { bem }
  }
}
</script>

<style lang="postcss">
.GenericStyledBanner {
  @apply relative flex items-center
    overflow-hidden rounded-[10px]
    px-md py-sm
    md:px-lg md:py-md;

  &__copy {
    @apply z-[1];
  }

  &__header {
    .DatoStructuredText__heading {
      @apply text-[26px] md:text-[38px] text-black;

      .GenericStyledBanner--text-light & {
        @apply text-white;
      }

      mark {
        @apply inline-block t-gradient;
      }
    }
  
    .DatoStructuredText__body {
      @apply text-[18px] md:text-[30px] text-black opacity-50 font-bold;

      .GenericStyledBanner--text-light & {
        @apply text-white;
      }
    }
  }

  &__img-wrapper {
    @apply absolute top-0 right-0 bottom-0 left-0;
  }

  &__img {
    @apply w-full h-full;
  }
}
</style>
